const locale = require('./emailEditorModal.i18n.json');

/*@ngInject*/
const EmailEditorModalController = function ($rootScope, $scope, $timeout, coreConstant, availableAttachments, options, loadingBarHandler, collaborationMediator,
                                             attachmentUtil, coreMediator, emailEditorConstant) {

    $scope.testOptions = {
        height: 400,
        focus: false,
        airMode: false,
        toolbar: [
            ['edit',['undo','redo']],
            ['headline', ['style']],
            ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
            ['fontface', ['fontname']],
            ['textsize', ['fontsize']],
            ['fontclr', ['color']],
            ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
            ['height', ['height']],
            ['table', ['table']],
            ['insert', ['link','picture','video','hr']],
            ['view', ['fullscreen', 'codeview']]
        ]
    };
    $scope.emailI18n = locale;
    $scope.availableAttachments= availableAttachments;
    $scope.selectedAttachments = _.clone(options.email.attachments);
    $scope.isAttachmentDropdownOpen=options.email.attachments.length > 0;
    $scope.options = options;
    $scope.draftTitle = $scope.emailI18n.draftTitle;
    $scope.addAnAttachmentText = $scope.emailI18n.attachmentTooltip,
    $scope.userList=options.userList;


    $scope.getTitle = function () {
        return $scope.draftTitle;
    };

    $scope.onCloseClick=function() {
        $rootScope.$broadcast(coreConstant.event.CLOSE_EMAIL_POPUP);
    }

    $scope.closePopup = function() {
        $scope.$close();
    }

    $scope.handleUploadAttachment = function (optionsData,data,selectedAttachments) {

        loadingBarHandler.showLoadingBar('submission.wizard.addDocumentActionModal.uploading');

        let submissionId = optionsData.email.submissionId,
            payload = attachmentUtil.getAttachmentPayload(data.attachment);

        payload = _.assign(payload, {
            'ownerUri': 'com.firstbest.underwriting.submission.Submission:' + submissionId,
            'submissionId': submissionId
        });

        collaborationMediator.uploadAttachmentEmail(optionsData.email.id, payload, data.file).then(function (newAttachment) {
            $scope.loadAttachments().then(function () {
                // automaticly attach to the email the newly added attachment
                // use the availableAttachments reference to inject inside the selectedAttachments array
                let filteredAttachment = _.filter($scope.availableAttachments, function (attachment) {
                    return newAttachment.id === attachment.id;
                });
                $scope.selectedAttachments = selectedAttachments;
                $scope.selectedAttachments.push(_.first(filteredAttachment));
                $scope.isAttachmentDropdownOpen = true;
                $rootScope.$broadcast(coreConstant.event.ATTACHMENT_UPDATED,$scope.availableAttachments,$scope.selectedAttachments, $scope.isAttachmentDropdownOpen);

            }).finally(function () {
                loadingBarHandler.hideLoadingBar();

            })
        });
    }

    $scope.loadAttachments = function() {
        return collaborationMediator.loadSubmissionAttachments(options.email.submissionId).then(function (submissionAttachmentList) {
            $scope.availableAttachments = submissionAttachmentList;
            if($scope.availableAttachments.length>0) {
                $scope.availableAttachments.push({name: $scope.addAnAttachmentText,addAttachment: true});
            }
        });
    }

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

};

angular.module('gw-um-submission')
    .controller('emailEditorModalController', EmailEditorModalController);
